//@flow
import {getTaxTypesApi} from '../api';
import type {TaxType} from '../../../../entities';

export function getTaxTypesService(countryCode: string): Promise<TaxType[]> {
  return getTaxTypesApi({country: countryCode}).toPromise();
}
